// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"styles_cardsContainer__2FcqR","teamCardSkeleton":"styles_teamCardSkeleton__3w47R","header":"styles_header__1JOCG","content":"styles_content__3NA2P"};